import React from "react";
import { EnvironmentOutlined, HomeOutlined, GlobalOutlined } from "@ant-design/icons";

const ZoneFilters = ({ 
  activeFilter = "all", 
  onFilterChange,
  total = 0,
  capital = 0,
  outside = 0
}) => {
  const filters = [
    {
      id: "all",
      label: "All Zones",
      count: total,
      icon: EnvironmentOutlined,
      color: "#00bcd4",
    },
    {
      id: "capital",
      label: "Capital",
      count: capital,
      icon: HomeOutlined,
      color: "#4caf50",
    },
    {
      id: "outside",
      label: "Outside",
      count: outside,
      icon: GlobalOutlined,
      color: "#ff9800",
    },
  ];

  return (
    <div style={{ marginBottom: "20px" }}>
      <div style={{ fontSize: "14px", color: "#666", marginBottom: "8px" }}>
        Filter Zones:
      </div>
      <div style={{ display: "flex", gap: "12px", flexWrap: "wrap" }}>
        {filters.map((filter) => {
          const Icon = filter.icon;
          const isActive = activeFilter === filter.id;

          return (
            <button
              key={filter.id}
              onClick={() => onFilterChange(filter.id)}
              style={{
                display: "flex",
                alignItems: "center",
                gap: "8px",
                padding: "10px 16px",
                border: isActive ? `2px solid ${filter.color}` : "2px solid #e0e0e0",
                borderRadius: "8px",
                background: isActive ? `${filter.color}15` : "white",
                color: isActive ? filter.color : "#666",
                fontSize: "14px",
                fontWeight: isActive ? "600" : "normal",
                cursor: "pointer",
                transition: "all 0.2s ease",
                outline: "none",
              }}
              onMouseEnter={(e) => {
                if (!isActive) {
                  e.currentTarget.style.background = "#f5f5f5";
                  e.currentTarget.style.borderColor = "#bdbdbd";
                }
              }}
              onMouseLeave={(e) => {
                if (!isActive) {
                  e.currentTarget.style.background = "white";
                  e.currentTarget.style.borderColor = "#e0e0e0";
                }
              }}
            >
              <Icon style={{ fontSize: "18px" }} />
              <span>
                {filter.label} ({filter.count})
              </span>
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default ZoneFilters;